/*

class to generate annotation

https://www.hl7.org/fhir/datatypes.html#Annotation

{
  "authorReference" : { Reference(Practitioner|Patient|RelatedPerson|Organization) },
  "authorString" : "<string>",
  "text" : "<markdown>" // R!  The annotation  - text content (as markdown)
}

*/
// Import variables
const Joi = require('joi');

// Create schema
const schema = {
  authorReference: Joi.string().required(),
  authorString: Joi.string().required(),
  text: Joi.string().required(),
};

// Define class
class Annotation {
  constructor ( obj ) {
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.Annotation = Annotation;
exports.annotationSchema = schema;